import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { del } from 'utils/http'

export const useWeeklyReportCreditsReset = () => {
  const customerId = useCustomerId()
  const queryClient = useQueryClient()
  const addNotification = useAddNotification()

  const resetQuota = () => del(`/management/customers/${customerId}/weekly_reports/delete_scheduled`)

  return useMutation({
    mutationFn: resetQuota,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['weeklyReportsCredits', customerId] })
      addNotification('Weekly report companies usage has been reset')
    },
    onError: (error: any) => {
      // utils/http throws the raw Response, so the status is on error.status.
      if (error?.status === 404) {
        return addNotification(
          'Unable to find any reports scheduled for deletion. Delete a report in the app first',
          'error',
        )
      }
      addNotification('Failed to reset weekly report companies usage', 'error')
    },
  })
}
